import { ajax } from "@/assets/js/ajax";
function hasId() {
  const href = window.location.href;
  return href.indexOf("id") > 0 ? true : false
}
export function formatAmount(value) {
    if (value === null || value === undefined) return '';
    // 转换为字符串处理
    let str = String(value).trim();
    // 移除所有非数字和非小数点的字符
    // str = str.replace(/[^\d.]/g, '')
    str = str.replace(/[^\d.]/g, '')
    
    // 限制只能有一个小数点
    const dotIndex = str.indexOf('.');
    if (dotIndex !== -1) {
        // 保留第一个小数点，移除后面所有的小数点
        str = str.slice(0, dotIndex + 1) + 
              str.slice(dotIndex + 1).replace(/\./g, '');
        // 限制小数点后最多两位
        const parts = str.split('.');
        if (parts.length > 1 && parts[1].length > 2) {
            str = parts[0] + '.' + parts[1].slice(0, 2);
        }
    }
    // 处理以多个0开头的情况（保留一个0）
    if (str.startsWith('0') && str.length > 1 && str[1] !== '.') {
        str = '0';
    }
    // 处理空值或仅小数点的情况
    if (str.startsWith('.')||str.startsWith('+')||str.startsWith('-')) {      
       str = '0'
    }
    if (str.endsWith('.') || 
        str.endsWith('.0') || 
        str.endsWith('.00') || 
        str.endsWith('.000')) {
        str = str.split('.')[0];
    }
    return str;
}
export function formatPhonevalue (number) {
    const strValue = String(number);
      const trimmed = strValue.replace(/\s+/g, '');
    const mobilePattern = /^1[3-9]\d{9}$/;
    const landlinePattern = /^((1[3-9]\d{9})|((\+?86-?)?0\d{2,3}-?\d{7,8}-?\d{0,4}))$/;
    // 验证手机号
    if (mobilePattern.test(trimmed)) {
        return {
            isValid: true
        };
    }

    // 验证座机号
    if (landlinePattern.test(trimmed)) {
        return {
            isValid: true
        };
    }

    // 都不匹配的情况
    return {
        isValid: false,
        message: '请输入有效的手机号（11位数字）或座机号（如010-12345678）'
    };
}
const Validator = {
  tels(rule, value, callback) {//手机号
    if (!value) {
      return callback(new Error('手机号不能为空'));
    }
    setTimeout(() => {
      if (!(/^1[3456789]\d{9}$/.test(value))) {
        callback(new Error('请输入正确的手机号码'));
      } else {
        callback();
      }
    }, 1000);
  },
  phone(rule, value, callback) {//办公电话
    if (!value) {
      return callback(new Error('办公电话不能为空'));
    }
    setTimeout(() => {
      if (!(/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/.test(value))) {
        callback(new Error('请输入正确的办公电话'));
      } else {
        callback();
      }
    }, 1000);
  },
  validateContact(rule,value,callback) {//判断是手机号还是座机号并验证规则
    if(value){
      const result = formatPhonevalue(String(value))
      if (!result.isValid) {
        callback(new Error(result.message));
      } else {
        callback()
      }
    }else{
      callback()
    }
  },
  email(rule, value, callback) {
    if (!value) {
      return callback(new Error('邮箱不能为空'));
    }
    setTimeout(() => {
      if (!(/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value))) {
        callback(new Error('请输入正确的公司邮箱'));
      } else {
        callback();
      }
    }, 1000);
  },
  chinaid(rule, value, callback) {
    if (!value) {
      return callback(new Error('请输入证件号码'));
    }
    setTimeout(() => {
      if (!(/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(value))) {
        callback(new Error('请输入正确的证件号码'));
      } else {
        if (hasId()) {
          callback();
        } else {
          ajax({
            url: "debtor/unique",
            data: { chinaid: value },
            type: "get",
            success: (e) => {
              callback();
            },
            fail: (e) => {
              callback(new Error('证件号码已存在'));
            }
          })
        }
      }
    }, 1000);

  },
  nChinaid(rule, value, callback) {
    if (!value) {
      return callback(new Error('请输入证件号码'));
    }
    setTimeout(() => {
      if (!(/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(value))) {
        callback(new Error('请输入正确的证件号码'));
      } else {
        callback()
        // if (hasId()) {
        //   callback();
        // } else {
        //   ajax({
        //     url: "debtor/unique",
        //     data: { chinaid: value },
        //     type: "get",
        //     success: (e) => {
        //       callback();
        //     },
        //     fail: (e) => {
        //       callback(new Error('证件号码已存在'));
        //     }
        //   })
        // }
      }
    }, 1000);

  },
  name(rule, value, callback) { //联系人姓名
    if (!value) {
      return callback();
    }
    setTimeout(() => {
      if (/^([^\u0000-\u00FF]|[a-zA-Z])*$/g.test(value)) {
        callback();
      } else {
        callback(new Error('联系人只能是汉字、字母'));
      }
    }, 1000);
  },
  companyName(rule, value, callback) { //公司名称
    if (!value) {
      return callback();
    }
    setTimeout(() => {
      if (/^([^\u0000-\u00FF]|[a-zA-Z]|\d)*$/g.test(value)) {
        callback();
      } else {
        callback(new Error('只能是汉字、字母和数字'));
      }
    }, 1000);
  },
  amount(rule, value, callback) {//本金/利息
    const formattedValue = formatAmount(value);
    if(rule.field != 'used_fee'){//本金
      if (!formattedValue||value == 0) { 
        return callback(new Error('请输入本金'));
      }
      setTimeout(() => {
        const amountStr = String(formattedValue).trim();
        const regex = /^(?:0|[1-9]\d{0,8})(?:\.\d{1,2})?$/;
        if (isNaN(Number(amountStr)) || amountStr === '.') {
          callback(new Error('请输入正确的金额'));
        }else if (!regex.test(amountStr)) {
          callback(new Error('超过最大金额限制'));
        }else if (amountStr.length > 12) {
          callback(new Error('超过最大金额限制'));
        }else{
          if (rule.field && this.form) {
            this.form[rule.field] = formattedValue;
          }
          callback()
        }
      }, 500);
    }else {//利息
      if(formattedValue){
        setTimeout(() => {
          const amountStr = String(formattedValue).trim();
          const regex = /^(?:0|[1-9]\d{0,8})(?:\.\d{1,2})?$/;
          if (isNaN(Number(amountStr)) || amountStr === '.') {
            callback(new Error('请输入正确的金额'));
          }else if (!regex.test(amountStr)) {
            callback(new Error('超过最大金额限制'));
          }else if (amountStr.length > 12) {
            callback(new Error('超过最大金额限制'));
          }else{
            if (rule.field && this.form) {
              this.form[rule.field] = formattedValue;
            }
            callback()
          }
        }, 500);
      }else{
        callback()
      }
    }
  },
  priceVal(rule, value, callback) {//诉讼相关费用
    const formattedValue = formatAmount(value);    
      if (!formattedValue||value == 0) { 
        return callback(new Error('请输入费用'));
      }
      setTimeout(() => {
        const amountStr = String(formattedValue).trim();
        const regex = /^(?:0|[1-9]\d{0,8})(?:\.\d{1,2})?$/;
        if (isNaN(Number(amountStr)) || amountStr === '.') {
          callback(new Error('请输入正确的金额'));
        }else if (!regex.test(amountStr)) {
          callback(new Error('超过最大金额限制'));
        }else if (amountStr.length > 12) {
          callback(new Error('超过最大金额限制'));
        }else{
          callback()
        }
      }, 500);
  }
}
export default Validator;
